import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Channel, Notification } from '@portals/api';
import { fadeIn, fadeIn1, fadeOut } from '@portals/utils';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ResponseService } from '@portals/core';

@Component({
	selector: 'web-modal-action',
	templateUrl: './modal-action.component.html',
	styleUrls: ['./modal-action.component.scss'],
	animations: [fadeIn, fadeIn1, fadeOut],
})
export class ModalActionComponent {
	channel = this.responseService.currentPage?.parameters?.channel as Channel;
	@Input() typeReady: boolean = false;
	@Input() isRecording: boolean = false;
	@Input() startAnimation: boolean = false;
	@Input() notification!: Notification;
	@Input() ctaWidth: string = '';
	@Output() closeModal = new EventEmitter<any>();
	isMobile = false;
	isIOS = false;
	constructor(private deviceService: DeviceDetectorService, private responseService: ResponseService) {
		this.isMobile = this.deviceService.isMobile();
		this.isIOS = this.deviceService.device == 'iPhone';
    }
	getBackgroundColor() {
		let theme;
		if (this.notification.links && this.notification.links.theme) {
			theme = this.notification.links.theme;
		} else {
			if (this.channel.links && this.channel.links.theme) {
				theme = this.channel.links.theme;
			}
		}
		if (theme && theme.background_color) {
			return { background: theme.background_color, 'background-color': theme.background_color };
		} else {
			// return { background: '#491176' };
			return {};
		}
	}
}
